import { Drawer, Space, Tag } from 'antd';
import CopyButton from '@/components/common/CopyButton';
import PayeeDetailBody from '@/components/payees/PayeeDetailBody';
import { payeeToClipboard } from '@/domain/payeeDetail';
import type { Payee } from '@/api/payees';

/**
 * 收款人详情抽屉（收款人页专用）。
 *
 * 展示**全部**表单字段，而不是挑几个：这一页的用途就是「把这个人的收款信息核对一遍、
 * 或者原样发给别人」。字段名直接用 Airwallex 下发的 path 翻出来的英文
 * （见 domain/payeeDetail.ts），不做中文映射表 —— 那等于承诺跟进全球清算系统的字段变更。
 *
 * 正文在 PayeeDetailBody，与打款申请 / 打款记录页的记录详情抽屉共用同一份渲染。
 */
export default function PayeeDetailDrawer({
  payee,
  open,
  onClose,
}: {
  payee: Payee | null;
  open: boolean;
  onClose: () => void;
}) {
  if (!payee) return null;

  return (
    <Drawer
      open={open}
      onClose={onClose}
      size={560}
      title={
        <Space size={8} wrap>
          <span>{payee.accountName ?? '收款人'}</span>
          <Tag>{payee.shortId}</Tag>
        </Space>
      }
      extra={<CopyButton text={payeeToClipboard(payee)} label="复制全部" type="default" successMessage="收款信息已复制" />}
    >
      <PayeeDetailBody payee={payee} />
    </Drawer>
  );
}
